import Vue from 'vue';
import App from './App.vue';
import router from './router';
//import * as Sentry from "@sentry/vue";

/*Sentry.init({
  App,
  dsn: "https://8c6d94360b036b390af77475dd951808@o4508688674586624.ingest.de.sentry.io/4508688695492689",
  integrations: [
],
});*/

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
